export default "__VITE_ASSET__C247idDW__"